export const MAKESWIFT_CACHE_TAG = '@@makeswift'
